import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export function useLanguage() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();

  const language = i18n.language as 'sv' | 'en';

  const setLanguage = useCallback(
    async (lng: 'sv' | 'en') => {
      await i18n.changeLanguage(lng);

      if (user?.id) {
        await supabase
          .from('profiles')
          .update({ language: lng } as any)
          .eq('id', user.id);
      }
    },
    [i18n, user?.id],
  );

  return { language, setLanguage, t };
}
